import { themeSettings } from '../settings';
const { loadLessText, loadMoreText, viewRepliesText, hideRepliesText } = themeSettings


const commentsBlocks = document.querySelectorAll( '.wp-block-comments' );

/**
 * Footer
 * @description - Comments scripts
 * @function
 * @return {void}
 */
const comments = () => {

	if ( !commentsBlocks ) {

		return;

	}

	commentsBlocks.forEach( ( commentBlock ) => {

		const commentsList = commentBlock.querySelector( '.wp-block-comment-template' )
		const allComments = commentBlock.querySelectorAll( '.comment.depth-1' )

		if ( allComments ) {

			allComments.forEach( ( comment, index ) => {

				if ( index > 1 ) {

					comment.classList.add( 'comment--hidden' )

				}

				const replies = comment.querySelectorAll( '.comment.depth-2' )
				const replyButton = comment.querySelector( '.wp-block-comment-reply-link' )

				if ( replies.length && replyButton ) {

					const viewRepliesButton = document.createElement( 'button' );
					const repliesList = comment.querySelector( 'ol' );
					const repliesListHeight = repliesList.scrollHeight

					repliesList.style.setProperty( '--replies-height', `${repliesListHeight}px` );
					viewRepliesButton.classList.add( 'comment__view-replies' );
					viewRepliesButton.textContent = `${viewRepliesText} (${replies.length})`;
					replyButton.appendChild( viewRepliesButton )


					viewRepliesButton.addEventListener( 'click', () => {

						if ( !viewRepliesButton.classList.contains( 'open' ) ) {

							viewRepliesButton.classList.add( 'open' )
							repliesList.classList.add( 'show' )
							viewRepliesButton.textContent = `${hideRepliesText} (${replies.length})`;

						} else {

							viewRepliesButton.classList.remove( 'open' )
							repliesList.classList.remove( 'show' )
							viewRepliesButton.textContent = `${viewRepliesText} (${replies.length})`;

						}

					} );


				}

			} )

			if ( allComments.length > 2 ) {

				const commentsLoadMore = document.createElement( 'button' );
				commentsLoadMore.classList.add( 'comment__load-more' );
				commentsLoadMore.textContent = `${loadMoreText} (${allComments.length - 2})`;
				commentsList.appendChild( commentsLoadMore )

				commentsLoadMore.addEventListener( 'click', () => {

					if ( !commentsLoadMore.classList.contains( 'is-active' ) ) {

						commentsLoadMore.classList.add( 'is-active' )
						commentsLoadMore.textContent = `${loadLessText}`;
						allComments.forEach( ( comment ) => {

							comment.classList.remove( 'comment--hidden' );

						} );

					} else {

						commentsLoadMore.classList.remove( 'is-active' )
						commentsLoadMore.textContent = `${loadMoreText} (${allComments.length - 2})`;
						allComments.forEach( ( comment, index ) => {

							if ( index > 1 ) {

								comment.classList.add( 'comment--hidden' );

							}

						} );

					}


				} );

			}


		}

	} );


}

export { comments };
